import React from "react";
import PropTypes from "prop-types";
import TextInput from "@cx/ui/TextInput";
import { MAX_SETTING_LENGTH } from "./SettingDisplayTypes";

export default class TextSettingType extends React.Component {
  static propTypes = {
    setting: PropTypes.object,
    settingName: PropTypes.string,
    updateSetting: PropTypes.func
  };

  state = {
    value: this.props.setting.value,
    isDisabled: true,
    setting: this.props.setting,
    settingName: this.props.settingName
  };

  updateSetting = event => {
    this.props.updateSetting(event);
  };

  render() {
    const { displayName } = this.props.setting;
    return (
      <div>
        <TextInput
          displayLabel={true}
          htmlId={"SettingType" + this.props.setting.name}
          name={this.props.setting.name}
          label={displayName}
          maxLength={MAX_SETTING_LENGTH}
          onChange={this.updateSetting}
          value={this.props.setting.value}
          getError={(_label, value) =>
            value && value.length >= MAX_SETTING_LENGTH
              ? `Value has reached the ${MAX_SETTING_LENGTH} character limit. Exceeding characters will be truncated.`
              : ""
          }
        />
      </div>
    );
  }
}
